export default class Zip {
  id: string = ''
  city: string = ''
  country: string = ''
  state: string = ''
}
